
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLanguages } from "slices/languageSlice";
import Api from "services/api"
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { CustomSwitch } from "components/common/Switch";
import { removeMultipleLanguages } from "slices/languageSlice";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import AddLanguageTiers from "components/languageTiers/AddLanguageTiers";
import ImportLanguage from "components/language/ImportLanguage";
import { languageTierSelector } from "slices/languageTierSlice";
import { fetchLanguagesTiers } from "slices/languageTierSlice";
import { removeMultipleLanguagesTiers } from "slices/languageTierSlice";
import { changeStatus } from "slices/languageTierSlice";
import { usePermissions } from "layouts/Admin";

const apiService = new Api();

function LanguageTiersList() {
  const dispatch = useDispatch()
  const { checkPermission } = usePermissions();
  const { languageTiers, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(languageTierSelector);

  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}
  });

  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [importModal, setImportModal] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([10])
  const [currentPage, setCurrentPage] = React.useState(1);
  const [exporting, setExporting] = React.useState(false);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });



  React.useEffect(() => {
    dispatch(fetchLanguagesTiers())
  }, [])

  const handleAddLanguagePopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchLanguagesTiers())
      hideConfirmDialog()
    }
    else {
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const handleRemoveItems = () => {
    dispatch(removeMultipleLanguagesTiers({ ids: selectedItems }, submitCallback))
  }
  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(languageTiers?.map((language) => language.id.toString()))


  }

  const handlePageChange = React.useCallback((page) => {
    setCurrentPage(page);
    dispatch(fetchLanguagesTiers(page));
  }, [])

  const handleClose = () => {
    // refAddutton.current.click(); 
    setAddForm({ show: false })
  };

  const handleOpenImportModal = () => {
    setImportModal(true);
  };

  const handleCloseImportModal = () => {
    setImportModal(false);
  };

  const handleSelect = (value) => {
    setSelectedValue(value)

  }


  //#region TABLE HEAD 

  const renderTableHeader = React.useCallback(() => {

    const callBack = (dir, sortBy) => {

      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchLanguagesTiers(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }
    return (
      <tr>
        <th>
          <div className="row_check">
            <span>#</span>
            {checkPermission('Delete Language Tiers') &&
              <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
            }
          </div>
        </th>
        <th >

          <TableHeaderItem
            title="Tier Name"
            sortBy="name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th>
          <TableHeaderItem
            title="Languages"
            sortBy="languages"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th >
          <TableHeaderItem
            title="Creation Date"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {checkPermission('Status Language Tiers') &&
          <th>Status</th>
        }
        {checkPermission('Edit Language Tiers') &&
          <th>Actions</th>
        }
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);

  //#endregion


  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return (
      languageTiers?.map((language, index) => (
        <LanguageItem language={language} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddLanguagePopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
      ))
    )
  }, [languageTiers, selectedItems]);

  //#endregion

  const renderAddButton = () => {
    return (
      <button
        type="button"
        className="main_button ml-4"
        onClick={handleAddLanguagePopUp}
        autoFocus
      >
        {"Add Tiers"}
      </button>
    )
  }

  const handleDownloadCsv = async () => {
    setExporting(true);
    try {
      const params = {
        sortBy: sortConfig.sortBy,
        sortDirection: sortConfig.sortDirection,
        search: searchTerm,
        pageLength,
      };
      const response = await Api.exportLanguageTiersCsv(params);
      if (response?.status >= 200 && response?.status < 300) {
        const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const fileName = response.headers['content-disposition']?.split('filename=')[1]?.replace(/"/g, '') || `language-tiers_${new Date().toISOString().slice(0,10)}.csv`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        const message = response?.data?.message || 'Export failed';
        toast.error(message, { className: 'errorToast' });
      }
    } catch (error) {
      toast.error('Export failed. Please try again.', { className: 'errorToast' });
    }
    setExporting(false);
  }

  return (
    <ListLayout
      heading="Language Tiers"
      time={true}
      title=""
      buttonTitle="Add Tiers"
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      totalPages={totalPages}
      fetchList={fetchLanguagesTiers}
      addButtonDisabled={!checkPermission('Create Language Tiers')}
      selectedItems={selectedItems}
      handleRemoveItems={handleRemoveItems}
      renderAddForm={(callback) => <AddLanguageTiers item={addForm.item} show={addForm.show} onClose={handleClose} callback={callback} statusPerm={checkPermission('Status Language Tiers')} />}
      refAddutton={refAddutton}
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddLanguagePopUp}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader || exporting}
      disableBootstrap
      sortConfig={sortConfig}
      defaultPageLength={pageLength}
      // renderAddButton={renderAddButton}

      noOfItems={total}
      searchPlaceholder="Search tiers ..."
      downloadCsv={true}
      onDownloadCsvClick={handleDownloadCsv}
      importBtnTitle= "Import Language Tier"
      importCsv={true}
      onImportClick={handleOpenImportModal}
    >

      {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
      <ImportLanguage show={importModal} onClose={handleCloseImportModal} callback={() => dispatch(fetchLanguagesTiers(1))} importType="language-tier"/>
    </ListLayout>
  )

}


const LanguageItem = ({
  language, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength, checkPermission
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = React.useState(language?.status == 1 ? 1 : 0 || 0);

  React.useEffect(() => {
    setStatus(language?.status == 1 ? 1 : 0 || 0)

  }, [language])
  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));

  }
  const getBackgroundStyle = (status) => {
    return status === 0 ? { background: '#f4f4f4' } : {};
  };

  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);

  return (
    <tr>
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission('Delete Language Tiers') &&
            <label className="custom-checkbox checkbox">
              <input type="checkbox" name="select-all" data-value={language.id} checked={selectedItems.includes(language.id.toString())} onChange={handleChange} />
              <span className="checkmark"></span>
            </label>
          }
        </div>
      </td>
      <td style={getBackgroundStyle(status)}>
        {language.name}
      </td>
      <td style={getBackgroundStyle(status)}>
        {language?.languages?.map(i => i.language?.name).join(', ')}
      </td>
      <td style={getBackgroundStyle(status)}>
        {/* {convertTimeToUTC(language.created_at)} */}
        {new Date(language?.created_at).toISOString().slice(0,16).replace("T", " ")}
      </td>
      {checkPermission('Status Language Tiers') &&
        <td style={getBackgroundStyle(status)}>
          <div className="row_check">
            <CustomSwitch handleChange={(status) => handleStatusChange(language?.id, status)} checked={status == 1 ? true : false} />
          </div>
        </td>
      }
      {checkPermission('Edit Language Tiers') &&
        <td style={getBackgroundStyle(status)}>
          <div className="row_check">
            <button className="table_edit" onClick={() => handleAddPopUp({ ...language, status })}>Edit</button>
          </div>
        </td>
      }
    </tr>
  )
}


export default LanguageTiersList;
